import React, { SyntheticEvent, useContext, useEffect, useState } from "react";
import { LocalizationContext } from "../../../../../../../../locales/Translation";
import { useDispatch, useSelector } from "react-redux";
import {
  dashboardDeskimoDayOfficeBookingFilterSelector,
  dashboardFilterDateRangeSelector,
  filterListPropertySelectedSelector,
} from "../../../../../../selectors/DashboardSelectors";
import { createDayOfficeBookingStatusFilterService } from "../../../../../../services/DashboardServices";
import {
  DAY_OFFICE_BOOKING_ALL_STATUS,
  DAY_OFFICE_BOOKING_CANCELLED_STATUS,
  DAY_OFFICE_BOOKING_COMPLETED_STATUS,
  DAY_OFFICE_BOOKING_CONFIRMED_STATUS,
  DAY_OFFICE_BOOKING_DECLINED_STATUS,
  DAY_OFFICE_BOOKING_NOT_REFUNDED_STATUS,
  DAY_OFFICE_BOOKING_PENDING_PAYMENT_STATUS,
  DAY_OFFICE_BOOKING_PENDING_REFUNDED_STATUS,
  DAY_OFFICE_BOOKING_PENDING_STATUS,
  DAY_OFFICE_BOOKING_REFUND_FILTER,
  DAY_OFFICE_BOOKING_REFUNDED_STATUS,
  PROPERTY,
} from "../../../../../../configs/Constants";
import { dashboardDeskimoDayOfficeBookingFilterAction } from "../../../../../../actions/DashboardActions";
import DropdownWithCheckboxMenu from "../../../../../../../../components/DropdownWithCheckboxMenu";
import { PUBLIC_URL } from "../../../../../../../App/configs/Constants";

const FilterDayOfficeBooking = () => {
  const { translations } = useContext(LocalizationContext);

  const dispatch = useDispatch();
  const dashboardDayOfficeBookingFilter = useSelector(
    dashboardDeskimoDayOfficeBookingFilterSelector
  );
  const dashboardFilterDateRange = useSelector(
    dashboardFilterDateRangeSelector
  );
  const filterListPropertySelected = useSelector(
    filterListPropertySelectedSelector
  );
  const [DayOfficeBookingStatus, setDayOfficeBookingStatus] = useState<
    { id: string; name: string }[]
  >([]);

  useEffect(() => {
    (async () => {
      try {
        await createDayOfficeBookingStatusFilterService({
          translations,
          setStatus: setDayOfficeBookingStatus,
          type: PROPERTY,
          deskimoAdmin: true,
        });
      } catch (e) {
        console.log("e", e);
      }
    })();
  }, [
    dashboardDayOfficeBookingFilter?.keyword,
    dashboardFilterDateRange,
    filterListPropertySelected,
  ]);

  const _onChangeFilter = (_: SyntheticEvent, data: any) => {
    if (data.value === DAY_OFFICE_BOOKING_ALL_STATUS) {
      if (data.checked) {
        dispatch(
          dashboardDeskimoDayOfficeBookingFilterAction({
            key: "filter_status",
            value: [
              DAY_OFFICE_BOOKING_ALL_STATUS,
              DAY_OFFICE_BOOKING_CONFIRMED_STATUS,
              DAY_OFFICE_BOOKING_PENDING_STATUS,
              DAY_OFFICE_BOOKING_DECLINED_STATUS,
              DAY_OFFICE_BOOKING_CANCELLED_STATUS,
              DAY_OFFICE_BOOKING_COMPLETED_STATUS,
              DAY_OFFICE_BOOKING_PENDING_PAYMENT_STATUS,
            ],
          })
        );
        dispatch(
          dashboardDeskimoDayOfficeBookingFilterAction({
            key: "filter_refund_status",
            value: [
              DAY_OFFICE_BOOKING_PENDING_REFUNDED_STATUS,
              DAY_OFFICE_BOOKING_REFUNDED_STATUS,
              DAY_OFFICE_BOOKING_NOT_REFUNDED_STATUS,
            ],
          })
        );
      } else {
        dispatch(
          dashboardDeskimoDayOfficeBookingFilterAction({
            key: "filter_status",
            value: [],
          })
        );
        dispatch(
          dashboardDeskimoDayOfficeBookingFilterAction({
            key: "filter_refund_status",
            value: [],
          })
        );
      }
      return;
    }

    if (data.checked) {
      if (DAY_OFFICE_BOOKING_REFUND_FILTER.includes(data.value)) {
        const newValue = [
          ...dashboardDayOfficeBookingFilter.filter_refund_status,
          data.value,
        ];
        dispatch(
          dashboardDeskimoDayOfficeBookingFilterAction({
            key: "filter_refund_status",
            value: newValue,
          })
        );
      } else {
        const newValue = [
          ...dashboardDayOfficeBookingFilter.filter_status,
          data.value,
        ];
        dispatch(
          dashboardDeskimoDayOfficeBookingFilterAction({
            key: "filter_status",
            value: newValue,
          })
        );
      }
      return;
    }

    if (DAY_OFFICE_BOOKING_REFUND_FILTER.includes(data.value)) {
      const newValue =
        dashboardDayOfficeBookingFilter.filter_refund_status.filter(
          (status: string) =>
            status !== data.value && status !== DAY_OFFICE_BOOKING_ALL_STATUS
        );
      dispatch(
        dashboardDeskimoDayOfficeBookingFilterAction({
          key: "filter_refund_status",
          value: newValue,
        })
      );
    } else {
      const newValue = dashboardDayOfficeBookingFilter.filter_status.filter(
        (status: string) =>
          status !== data.value && status !== DAY_OFFICE_BOOKING_ALL_STATUS
      );
      dispatch(
        dashboardDeskimoDayOfficeBookingFilterAction({
          key: "filter_status",
          value: newValue,
        })
      );
    }
  };

  const updateFilterCheckedStatus = (
    filter: { id: string; checked: any },
    dashboardDayOfficeBookingFilter: {
      filter_refund_status: any;
      filter_status: any;
    }
  ) => {
    const isRefundFilter = DAY_OFFICE_BOOKING_REFUND_FILTER.includes(filter.id);
    const filterList = isRefundFilter
      ? dashboardDayOfficeBookingFilter.filter_refund_status
      : dashboardDayOfficeBookingFilter.filter_status;

    filter.checked = filterList?.includes(filter.id);
    return filter;
  };

  return (
    <div className={"dropdown-filter"}>
      <DropdownWithCheckboxMenu
        onChange={_onChangeFilter}
        listCheckBox={DayOfficeBookingStatus.map((filter: any) =>
          updateFilterCheckedStatus(filter, dashboardDayOfficeBookingFilter)
        )}
        label={translations.filters}
        icon={
          <img
            alt={"Deskimo"}
            src={PUBLIC_URL + "/assets/icons/icon-filter.svg"}
          />
        }
      />
    </div>
  );
};

export default FilterDayOfficeBooking;
